import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import styles from './Badge.module.scss';

export type BadgeVariants = 'isNew' | 'isPromo' | 'isNews';

type BadgeProps = {
    variant: BadgeVariants;
    customText?: string;
    className?: string;
};

export const Badge: FunctionComponent<BadgeProps> = (props) => {
    const { variant, customText, className } = props;

    const badgeText: { [key in BadgeVariants]: string } = {
        isNew: 'Новинка',
        isNews: 'Новость',
        isPromo: 'Акция',
    };

    return (
        <div className={clsx(styles.root, styles[`${variant}Variant`], className)}>
            {customText !== undefined ? customText : badgeText[variant]}
        </div>
    );
};
